/* Executive-minimalist tokens (shared by /report/* screens).
   Values come from the single source of truth in ./tokens.js — do not hardcode. */
import { COLORS, RADIUS, FONT, SELECT_STYLES } from './tokens';

/* SELECT_STYLES is re-exported so existing `import { SELECT_STYLES } from '.../txStyles'`
   keeps working and renders identically to <PCSelect> (bordered white). */
export { SELECT_STYLES };

export const CARD = {
    background: COLORS.surface,
    borderRadius: RADIUS.card,
    boxShadow: 'none',
    border: `1px solid ${COLORS.border}`
};

export const COL_HEAD = {
    fontWeight: 600,
    fontSize: 12,
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    color: COLORS.textDim,
    padding: '12px 16px',
    background: COLORS.surfaceAlt,
    borderBottom: `1px solid ${COLORS.border}`,
    whiteSpace: 'nowrap'
};

export const INPUT = {
    background: COLORS.surface,
    border: `1px solid ${COLORS.border}`,
    borderRadius: RADIUS.input,
    padding: '10px 14px',
    fontSize: 14,
    fontFamily: FONT,
    width: '100%',
    boxSizing: 'border-box'
};

export const LABEL = {
    fontWeight: 500,
    fontSize: 12,
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    color: COLORS.textDim,
    display: 'block',
    marginBottom: 6
};

export function ToggleSwitch({ options, value, onChange, disabled }) {
    return (
        <div style={{ display: 'flex', background: COLORS.surfaceAlt, padding: 3, borderRadius: RADIUS.card, border: `1px solid ${COLORS.border}` }}>
            {options.map(opt => (
                <button
                    key={opt}
                    disabled={disabled}
                    onClick={() => !disabled && onChange(opt)}
                    style={{
                        flex: 1,
                        padding: '6px 16px',
                        borderRadius: 6,
                        border: 'none',
                        fontWeight: 600,
                        fontSize: 12,
                        background: value === opt ? COLORS.surface : 'transparent',
                        color: value === opt ? COLORS.primary : COLORS.textDim,
                        boxShadow: value === opt ? '0 1px 3px rgba(0,0,0,0.08)' : 'none',
                        cursor: disabled ? 'not-allowed' : 'pointer',
                        opacity: disabled ? 0.6 : 1,
                        whiteSpace: 'nowrap',
                        transition: 'all 0.15s'
                    }}
                >
                    {opt.toUpperCase()}
                </button>
            ))}
        </div>
    );
}
